import Vue from 'vue'
import Router from 'vue-router'


//解决路由重复报错问题
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
// 样例
// import HelloWorld from '@/components/HelloWorld'
//后期检查的时候搜索--后期删除---文字，然后删除该链接
// -----------------------用户控制台----------------------------

//用户控制台
const index = () => import('@/components/manage/index')

//用户控制台-管理设备
const managefacility = () => import('@/components/manage/managefacility/index')

//用户控制台-报警信息
const warning = () => import('@/components/manage/warning')

//用户控制台-设备历史数据
const historicalData = () => import('@/components/manage/historicalData')
//用户控制台-维护日志
const maintenanceLog = () => import('@/components/manage/maintenanceLog')

//用户控制台-项目管理
const MFprojectManagement = () => import('@/components/manage/project/index')
//用户控制台-项目管理-添加项目
const addPInfo = () => import('@/components/manage/project/addPInfo')


//用户控制台-部门信息/部门管理
const userManagement = () => import('@/components/manage/userManagement')
//用户控制台-部门信息/部门管理
const editWork = () => import('@/components/manage/editWork')



//用户控制台---我的公司
const myCompany = () => import('@/components/manage/myCompany')
//用户控制台-消息列表
const noticeList = () => import('@/components/manage/noticeList')
//用户控制台-消息详情
const noticeDetails = () => import('@/components/manage/noticeDetails')


// -----------------后台-------------------------

//后台-登录密码
const bkLoginTwo= () => import('@/components/backstage/bkLogin')
//后台-登录验证码
const codeLogin= () => import('@/components/backstage/codeLogin')
//后台-主页
const bkIndex = () => import('@/components/backstage/layout/index')
//后台-客户
const bkkeHu = () => import('@/components/backstage/keHu')
//后台-添加项目
const addProject = () => import('@/components/backstage/addProject')
//后台-回收站
const recycleBin = () => import('@/components/backstage/recycleBin')
//后台-客户-查看用户设备
const bkmanagefacility = () => import('@/components/backstage/managefacility')
//后台-客户-查看用户设备--组态图
const bMFconfiguration = () => import('@/components/backstage/MFconfiguration')
//后台-客户-查看用户设备--机械数据
const bMFMechanics = () => import('@/components/backstage/MFMechanics')
//后台-查看设备维修记录列表
const bkequipmentList= () => import('@/components/backstage/equipmentList')
//后台-查看设备维修记录
const bkrepair= () => import('@/components/backstage/repair')
//后台-用户管理
const bkuserManagement= () => import('@/components/backstage/userManagement')
//后台-下载中心
const DownloadCenter= () => import('@/components/backstage/DownloadCenter')
// -------------工程师相关页面 start
//后台-工单管理
const bkworkOrder= () => import('@/components/backstage/workOrder')
// 添加工单
const bkaddworkOrder= () => import('@/components/backstage/addworkOrder')
// 投标详情
const tenderDetails= () => import('@/components/backstage/tenderDetails')
// 详情
const biding= () => import('@/components/backstage/biding')
// 工程师标签全部展示
const engineerTags= () => import('@/components/backstage/engineerTags')
// 平台规章，页面在工程师模块，这里是才创建一个路由）
const platformregula= () => import('@/components/engineer/PlatformRegulations/platformregulations')
// 财务管理相关
// 工程师提现状态
const bkWithdrawal= () => import('@/components/backstage/engineerFinancialManagement/Withdrawal')
// 提现详情
const bkWithdrawalDetails= () => import('@/components/backstage/engineerFinancialManagement/WithdrawalDetails')
// 财务记录（工程师财务详情 进入页）
const bkengineerhistory= () => import('@/components/backstage/engineerFinancialManagement/engineerhistory')
// 工程师财务详情（历史收入、历史提现 进入页）
const bkEngineerFinance= () => import('@/components/backstage/engineerFinancialManagement/EngineerFinance')
//后台-工程师管理
const engineerSupervise= () => import('@/components/backstage/engineerSupervise')
//后台-工程师管理
const engineerDetails= () => import('@/components/backstage/engineerDetails')
// -------------工程师相关页面 end

//后台-上传解决方案
const bkuploadFile= () => import('@/components/backstage/uploadFile')
//后台-预览解决方案
const bkviewDocx= () => import('@/components/backstage/viewDocx')
//后台-更新知识库
const bkknowledge= () => import('@/components/backstage/knowledge')

//后台-更新知识库-问题描述
const bkKLDet= () => import('@/components/backstage/KLDet')
//后台-更新知识库-解决方案
const bkSolveDet= () => import('@/components/backstage/SolveDet')
//后台-知识详情页面
const details= () => import('@/components/backstage/details')
//后台-更新行业资讯
const bknews= () => import('@/components/backstage/news')
//后台-更新行业资讯--新增页面
const newsDet= () => import('@/components/backstage/newsDet')
//后台-更新行业资讯--详情
const newsDetails= () => import('@/components/backstage/newsDetails')
//后台-配件库配置
const parts= () => import('@/components/backstage/BKparts/index')
//后台-新增配件
const addparts= () => import('@/components/backstage/BKparts/addparts')
//后台-选择新建配件库类目
const SelectCategory= () => import('@/components/backstage/BKparts/SelectCategory')
//后台-注册公司列表
const companylist= () => import('@/components/backstage/companylist')
//后台-创建公司
const CreateCompany= () => import('@/components/backstage/CreateCompany')
//后台-查看用户留言列表
const viewMessage= () => import('@/components/backstage/viewMessage')
//后台-查看用户留言详情
const messageDetails= () => import('@/components/backstage/messageDetails')
//后台-关联用户页面
const signproject= () => import('@/components/backstage/signproject')
//用户控制台-项目管理--采集设备名称
const applycollectdevice= () => import('@/components/backstage/applycollectdevice')
//用户控制台-项目管理--采集设备属性值
const perfectInfo= () => import('@/components/backstage/perfectInfo')
//后台-项目管理
const bkprojectManagement= () => import('@/components/backstage/projectManagement')
//后台-添加项目
const bkaddprojectManagement= () => import('@/components/backstage/addprojectManagement')
//后台-添加项目
const bkseeProjectManagement= () => import('@/components/backstage/seeProjectManagement')
//后台-查看采集设备详情
const bkcollectInformation= () => import('@/components/backstage/collectInformation')
//后台-查看机械设备属性
const mechanicsDetails= () => import('@/components/backstage/mechanicsDetails')
//后台-设备历史数据
const BhistoricalData = () => import('@/components/backstage/historicalData')
//后台-我的设备-参数
const BparameterInfo = () => import('@/components/backstage/parameterInfo')
//后台-查看机械设备参数
const mechanicsParameter= () => import('@/components/backstage/mechanicsParameter')
//后台-添加机械设备参数
const addParameter= () => import('@/components/backstage/addParameter')
//后台-机械设备维修日志
const bkMaintenanceLog= () => import('@/components/backstage/bkMaintenanceLog')
//后台-添加机械设备维修日志
const addMaintenanceLog= () => import('@/components/backstage/addMaintenanceLog')
//后台-查看机械设备维修日志详情
const logDetails= () => import('@/components/backstage/logDetails')
//后台-系统管理-标签管理
const tagmanage= () => import('@/components/backstage/system/tagmanage')
//后台-系统管理-全部数据采集模块
const acquisitionModule= () => import('@/components/backstage/system/acquisitionModule')
//后台-系统管理-配件库类目
const CategoryParts= () => import('@/components/backstage/system/CategoryParts')
//后台-系统管理-直播管理界面
const live= () => import('@/components/backstage/live')
//后台-系统管理-解决方案管理界面
const programme= () => import('@/components/backstage/programmeList')
//后台-系统管理-解决方案添加界面
const addProgramme= () => import('@/components/backstage/addProgramme')
//后台-系统管理-录播视频管理界面
const bkRecordVideo= () => import('@/components/backstage/recordVideo/index')
//后台-系统管理-录播视频添加界面
const addVideo= () => import('@/components/backstage/recordVideo/addVideo')

// -----------------公放和注册登录-------------------------

//登录接口
// {
//   path:"/login",
//   component:login,
// },
// const login = () => import('@/components/login/newLogin')
//用户注册协议
const protocolForUsrPass = () => import('@/components/login/protocolForUsrPass')
//完善用户信息
const UserInformation = () => import('@/components/login/UserInformation')
//完善用户信息---更改密码
const UIChangepassword = () => import('@/components/login/Changepassword')
//完善用户信息---编辑和查询用户信息
const UItwo = () => import('@/components/login/UItwo')
//完善用户信息---管理我的标签
const myTags = () => import('@/components/login/myTags')
//完善用户信息---查看用户的收藏
const UIcollect = () => import('@/components/login/UIcollect')
//完善用户信息---创建公司
const createcompany = () => import('@/components/login/createcompany')
//完善用户信息---加入公司
const joincompany = () => import('@/components/login/joincompany')
//上传用户头像测试单拉出来的页面---后期删除
const xxdetfult = () => import('@/components/login/xxdetfult')
//上传用户头像测试单拉出来的页面---后期删除
const jump = () => import('@/components/login/jump')
//工程师添加
const applyEngineer = () => import('@/components/login/applyEngineer')
//用户信息审核
const auditInfo = () => import('@/components/login/auditInfo')
//公放-主页
const homeIndex = () => import('@/components/home/index')
//公放-配件库
const partsShoppingCenter = () => import('@/components/home/partsShoppingCenter/index')
//公放-配件库-详情页
const partsDetails = () => import('@/components/home/partsShoppingCenter/partsDetails')
//公放-解决方案这一页
const solutions = () => import('@/components/home/solutions')
//公放-企业动态每条相同的内容
const articleDetails = () => import('@/components/home/articleDetails')
//公放-录播视频页面
const recordVideo = () => import('@/components/home/recordVideo')
//公放-直播视频页面
const liveVideo = () => import('@/components/home/live')
//公放-录播视频详情页面
const videoDetails = () => import('@/components/home/videoDetails')
//公放-行业资讯详情
const newsDetH = () => import('@/components/home/newsDetH')
//公放-关于我们
const aboutUs = () => import('@/components/home/aboutUs')
//公放-服务中心
const ServiceCentre = () => import('@/components/home/ServiceCentre')
//公放-资料下载
const DataDownload = () => import('@/components/home/DataDownload')
//公放-知识库
const knowledge = () => import('@/components/home/knowledge')
//公放-行业资讯
const news = () => import('@/components/home/news')
//公放-知识问答
const KnowledgeQAndA = () => import('@/components/home/KnowledgeQAndA/index')
//公放-我要提问
const putQuestions = () => import('@/components/home/KnowledgeQAndA/putQuestions')
//公放-提问详情
const problemDetails = () => import('@/components/home/KnowledgeQAndA/problemDetails')


//大屏设计
//中间屏幕
const center = () => import('@/components/visual/center')
//左侧屏幕
const left = () => import('@/components/visual/left')
//右侧屏幕
const right = () => import('@/components/visual/right')


// 工程师开发内容
//工程师控制台主页
const engineerIndex = () => import('@/components/engineer/index')
//项目展示
const ProjectDisplay = () => import('@/components/engineer/ProjectDisplay')
//我的项目
const mybid = () => import('@/components/engineer/mybid')
//我的评价
const score = () => import('@/components/engineer/score')
//项目详情页面
const proDetails = () => import('@/components/engineer/proDetails')
//财务管理
const finance = () => import('@/components/engineer/finance')
//技术方案页面
const tecProgramme = () => import('@/components/engineer/tecProgramme')
//冻结列表
const frozen = () => import('@/components/engineer/frozen')
//认证页面
const authentication = () => import('@/components/engineer/authentication')
//落标页面
const failBiding = () => import('@/components/engineer/failBiding')
//支付宝提现走流程页面
const aipayWithdrawal = () => import('@/components/engineer/AlipayWithdrawal')
//银行卡提现走流程页面
const bankCardWithdrawal = () => import('@/components/engineer/bankCardWithdrawal')
//提现页面
const withdrawalPage = () => import('@/components/engineer/WithdrawalPage')
// 工程师标签全部展示（在后台，这里在创建一个路由只为过验证）
const engineerTagALL= () => import('@/components/backstage/engineerTags')
//平台规章
const platformregulations = () => import('@/components/engineer/PlatformRegulations/platformregulations')

Vue.use(Router)

const constantRoutes =[
  {
    path:"/bkLogin",
    component:bkLoginTwo,
  },
  {
    path:"/codeLogin",
    component:codeLogin,
  },
  {
    path:"/protocolForUsrPass",
    component:protocolForUsrPass,
  },
  {//用户个人中心
    path:"/UserInformation",
    component:UserInformation,
    children:[
      {
        path:'UIChangepassword',
        component:UIChangepassword
      },
      {
        path:'UItwo',
        component:UItwo
      },
      {
        path:'myTags',
        component:myTags
      },
      {
        path:'UIcollect',
        component:UIcollect
      },
      {
        path:'createcompany',
        component:createcompany
      },
      {
        path:'joincompany',
        component:joincompany
      },
      {
        path:'applyEngineer',
        component:applyEngineer
      },
      {
        path:'auditInfo',
        component:auditInfo
      },
      {
        path:'',
        redirect:'/UserInformation/UItwo'
      }
    ]
  },
  {
    path:"/xxdetfult",
    component:xxdetfult,
  },
  {
    path:"/jump",
    component:jump,
  },
  {
    path:"/homeIndex",
    component:homeIndex,
  },
  {
    path:"/partsShoppingCenter",
    component:partsShoppingCenter,
  },
  {
    path:"/partsDetails",
    component:partsDetails,
  },
  {
    path:"/solutions",
    component:solutions,
  },
  {
    path:"/articleDetails",
    component:articleDetails,
  },
  {
    path:"/recordVideo",
    component:recordVideo,
  },
  {
    path:"/liveVideo",
    component:liveVideo,
  },
  {
    path:"/videoDetails",
    component:videoDetails,
  },
  {
    path:"/newsDetH",
    component:newsDetH,
  },
  {
    path:"/aboutUs",
    component:aboutUs,
  },
  {
    path:"/ServiceCentre",
    component:ServiceCentre,
  },
  {
    path:"/DataDownload",
    component:DataDownload,
  },
  {
    path:"/KnowledgeQAndA",
    component:KnowledgeQAndA,
  },
  {
    path:"/putQuestions",
    component:putQuestions,
  },
  {
    path:"/problemDetails",
    component:problemDetails,
  },
  {
    path:"/knowledge",
    component:knowledge,
  },
  {
    path:"/news",
    component:news,
  },
  {
    path:"*",
    redirect:"/homeIndex"
  }
]
const backstageRoutes = [

  {//这是后台的控制台
    path:"/bkIndex",
    component:bkIndex,
    children:[
      {
        path:"bkkeHu",
        component:bkkeHu,
      },
      {
        path:"addProject",
        component:addProject,
      },
      {
        path:"recycleBin",
        component:recycleBin,
      }, 
      {
        path:"bkmanagefacility",
        component:bkmanagefacility,
      },
      {
        path:"bMFconfiguration",
        component:bMFconfiguration,
      },
      {
        path:"bMFMechanics",
        component:bMFMechanics,
      },
      {
        path:"bkrepair",
        component:bkrepair,
      },
      {
        path:"bkuserManagement",
        component:bkuserManagement,
      },
      {
        path:"DownloadCenter",
        component:DownloadCenter,
      },
      {
        path:"bkequipmentList",
        component:bkequipmentList,
      },
      {
        path:"bkworkOrder",
        component:bkworkOrder
      },
      {
        path:"bkaddworkOrder",
        component:bkaddworkOrder
      },
      {
        path:"tenderDetails",
        component:tenderDetails
      },
      {
        path:"biding",
        component:biding
      },
      {
        path:"platformregula",
        component:platformregula
      },
      {
        path:"bkuploadFile",
        component:bkuploadFile
      },
      {
        path:"engineerTags",
        component:engineerTags
      },
      {
        path:"bkWithdrawal",
        component:bkWithdrawal
      },
      {
        path:"bkWithdrawalDetails",
        component:bkWithdrawalDetails
      },
      {
        path:"bkengineerhistory",
        component:bkengineerhistory
      },
      {
        path:"bkEngineerFinance",
        component:bkEngineerFinance
      },
      {
        path:'bkknowledge',
        component:bkknowledge
      },
      {
        path:'live',
        component:live
      },
      {
        path:'programme',
        component:programme
      },
      {
        path:'addProgramme',
        component:addProgramme
      },
      {
        path:'bkRecordVideo',
        component:bkRecordVideo
      },
      {
        path:'addVideo',
        component:addVideo
      },
      {
        path:'bkKLDet',
        component:bkKLDet
      },
      {
        path:'bkSolveDet',
        component:bkSolveDet
      },
      {
        path:'bknews',
        component:bknews
      },
      {
        path:'newsDet',
        component:newsDet
      },
      {
        path:'newsDetails',
        component:newsDetails
      },
      {
        path:'parts',
        component:parts
      },
      {
        path:'addparts',
        component:addparts
      },
      {
        path:'SelectCategory',
        component:SelectCategory
      },
      {
        path:'companylist',
        component:companylist
      },
      {
        path:'CreateCompany',
        component:CreateCompany
      },
      {
        path:'viewMessage',
        component:viewMessage
      },
      {
        path:'messageDetails',
        component:messageDetails
      },
      {
        path:'details',
        component:details
      },
      {
        path:'bkprojectManagement',
        component:bkprojectManagement
      },
      {
        path:'bkaddprojectManagement',
        component:bkaddprojectManagement,
        children:[
          {
            path:'signproject',
            component:signproject
          },
          {
            path:'applycollectdevice',
            component:applycollectdevice
          },
          {
            path:'perfectInfo',
            component:perfectInfo
          },
        ]
      },
      {
        path:'bkseeProjectManagement',
        component:bkseeProjectManagement,
        children:[
          {
            path:'signproject',
            component:signproject
          },
          {
            path:'applycollectdevice',
            component:applycollectdevice
          },
          {
            path:'perfectInfo',
            component:perfectInfo
          },
        ]
      },
      {
        path:'bkcollectInformation',
        component:bkcollectInformation,
      },
      {
        path:'mechanicsDetails',
        component:mechanicsDetails,
      },
      {
        path:'BhistoricalData',
        component:BhistoricalData,
      },
      {
        path:'BparameterInfo',
        component:BparameterInfo,
      },
      {
        path:'mechanicsParameter',
        component:mechanicsParameter,
      },
      {
        path:'bkMaintenanceLog',
        component:bkMaintenanceLog,
      },
      {
        path:'logDetails',
        component:logDetails,
      },
      {
        path:'tagmanage',
        component:tagmanage,
      },
      {
        path:'acquisitionModule',
        component:acquisitionModule,
      },
      {
        path:'CategoryParts',
        component:CategoryParts,
      },
      {
        path:'engineerSupervise',
        component:engineerSupervise,
      },
      {
        path:'engineerDetails',
        component:engineerDetails,
      },
      {
        path:'addMaintenanceLog',
        component:addMaintenanceLog,
      },
      {
        path:'addParameter',
        component:addParameter,
      },
      {
        path:'',
        redirect:'/bkIndex/bkkeHu'
      }
    ]
  },
  {
    path:"/bkviewDocx",
    component:bkviewDocx
  },
]
const userConsoleRoutes = [
  {//这是用户控制台
    path:"/index",
    component:index,
    children:[
      {
        path:'managefacility',
        component:managefacility,
      },
      {
        path:'warning',
        component:warning,
      },
      {
        path:'MFprojectManagement',
        component:MFprojectManagement,
      },
      {
        path:'addPInfo',
        component:addPInfo,
      },
      {
        path:'noticeList',
        component:noticeList,
      },
      {
        path:'noticeDetails',
        component:noticeDetails,
      },
      {
        path:'maintenanceLog',
        component:maintenanceLog,
      },
      {
        path:'historicalData',
        component:historicalData,
      },
      {
        path:'userManagement',
        component:userManagement,
      },
      {
        path:'editWork',
        component:editWork,
      },
      {
        path:'myCompany',
        component:myCompany
      },
      {
        path:'',
        redirect:'/index/MFprojectManagement'
      }
    ]
  },
  {
    name:'/center',
    path:"/center",
    component:center,
    meta: {
      title: "主屏",
    }
  },
  {
    name:'left',
    path:"/left",
    component:left,
    meta: {
      title: "KPI屛",
    }
  },
  {
    name:'right',
    path:"/right",
    component:right,
    meta: {
      title: "告警屛",
    }
  },
]
const engineerRoutes = [
  {// 工程师模块
    path:"/engineerIndex",
    component:engineerIndex,
    children:[
      {
        path:"ProjectDisplay",
        component:ProjectDisplay,
      },
      {
        path:"mybid",
        component:mybid,
      },
      {
        path:"score",
        component:score,
      },
      {
        path:"proDetails",
        component:proDetails,
      },
      {
        path:"finance",
        component:finance,
      },
      {
        path:"tecProgramme",
        component:tecProgramme,
      },
      {
        path:"frozen",
        component:frozen,
      },
      {
        path:"authentication",
        component:authentication,
      },
      {
        path:"failBiding",
        component:failBiding,
      },
      {
        path:"aipayWithdrawal",
        component:aipayWithdrawal,
      },
      {
        path:"bankCardWithdrawal",
        component:bankCardWithdrawal,
      },
      {
        path:"withdrawalPage",
        component:withdrawalPage,
      },
      {
        path:"engineerTagALL",
        component:engineerTagALL,
      },
      {
        path:"platformregulations",
        component:platformregulations,
      },
      {
        path:'',
        redirect:'/engineerIndex/ProjectDisplay'
      }
    ]
  },
]
let reslutData=[constantRoutes,backstageRoutes,userConsoleRoutes,engineerRoutes]
var routesData = [];
reslutData.map(function (value, index, array) {
  routesData = routesData.concat(value);
});

export {
  constantRoutes,
  backstageRoutes,
  userConsoleRoutes,
  engineerRoutes,
  routesData,
}

export default new Router({
  routes: routesData
})



// WEBPACK FOOTER //
// ./src/router/index.js